import React, { useState, useEffect } from 'react'
import { FormGroup, Panel, Input, Row, Col, Checkbox } from 'rsuite'

export default function SummaryReviseRequestViewWidget({
  schema: _schema,
}) {
  const [schema, setSchema] = useState(_schema)

  console.log('_schema revise', _schema)

  const renderPanel = (panel, index) => {
    return (
      <Panel  collapsible defaultExpanded key={panel.id}>
        <>
          {panel.subItems.map((subject, index) => {
            return renderSubject(subject, index)
          })}
        </>
      </Panel>
    )
  }

  const renderSubject = (subject, index) => {
    return subject?.selected && (
      <Row key={subject.id} style={{ marginTop: 0 }}>
        <Col md={23} style={{ padding: '0px', marginTop: -10 }}>
          <Panel
            header={subject.label}
            defaultExpanded
            expanded={subject.selected}
          >
            <FormGroup>
              {subject.subItems.length === 0 ? (
                subject.selected &&  <>
                  {/* <Input
                    name={subject.id}
                    componentClass="textarea"
                    rows={3}
                    style={{ width: '100%', resize: 'auto', marginTop: 0 }}
                    placeholder={subject.placeholder}
                    defaultValue={subject.value}
                    disabled={!subject.enableInput}
                  /> */}
                  <div
                    style={{ whiteSpace: 'pre-line', }} // ใส่เพื่อให้ render \n ได้
                    dangerouslySetInnerHTML={{
                      __html: subject.value,
                    }}
                  />
                </>
              ) : (
                <>
                  {subject.subItems.map((sub, index) => {
                    return renderSub(sub, index)
                  })}
                </>
              )}
            </FormGroup>
          </Panel>
        </Col>
      </Row>
    )
  }

  const renderSub = (sub, index) => {
    return (
      <Row key={index}>
        {sub.selected && (
          <Row style={{ marginLeft: 30 }}>
            {/* <Input
              name={sub.id}
              componentClass="textarea"
              defaultValue={sub.value}
              disabled={!sub.enableInput}
              placeholder={sub.placeholder}
            /> */}
            <div
              style={{ whiteSpace: 'pre-line' }} // ใส่เพื่อให้ render \n ได้
              dangerouslySetInnerHTML={{
                __html: sub.value,
              }}
            />
          </Row>
        )}
      </Row>
    )
  }

  return (
    <>
      {schema &&
        schema.map((panel, index) => {
          return renderPanel(panel, index)
        })}
    </>
  )
}
